<section class="banner-section">
    <div class="container">
        <div class="row g-0">
            <div class="col-lg-6 col-md-12">
                <div class="banner" [ngClass]="{'rtl': isArabic}">                    
                    <h1>
                         @if(isArabic){ استمع واستمتع مع راديو الغردقة } @else { Listen and Enjoy With Hurghada Radio }
                    </h1>
                </div>
                <div class="social-links" [ngClass]="{'rtl': isArabic}">
                    @for (item of socials; track $index) {
                        <a [href]="item.link" target="_blank"> <i [class]="item.icon"></i> </a>
                    }
                </div>
                <div class="text-center">
                    <button class="btn btn-primary m-1 text-center" [ngClass]="{'vibration shadow-lg': !audioService.isPlaying}" (click)="toggleRadio()">
                        @if (!audioService.isPlaying) {
                            <span>
                                @if (isArabic) {  تشغيل الراديو } @else { play the radio }
                                <i class="fa-solid fa-play"></i>
                            </span>
                        }
                        @else {
                            <span>
                                @if (isArabic) { توقف } @else { Pause }
                                <i class="fa-solid fa-stop"></i>
                            </span>
                        }
                    </button>
                    <a class="btn btn-primary m-1 text-center" routerLink="/news">
                      @if (isArabic) { أخر الأخبار } @else { News }
                      <i class="fa-solid fa-newspaper mx-2"></i>
                    </a>
                </div>    
            </div>
        </div>
    </div>
    <div class="music-icon"> 🎧 </div>
    <div class="banner-right-img d-lg-block d-none"></div>
</section>

<section class="live py-5">
    <div class="container">
        <div class="row g-3">
            <div class="col-md-2 col-6 m-auto">
                <div class="play-live-images">
                    <img src="assets/images/home/music.jpg" draggable="false" class="w-100 music" alt="live img">
                    <img src="assets/images/home/circle.png" draggable="false" class="w-100 circle" [ngClass]="{'spin': audioService.isPlaying}" alt="live img"> 
                    <div class="audio-visualizer mt-3" [ngClass]="{'opacity-100': audioService.isPlaying}">
                        <div class="bar"></div> 
                        <div class="bar"></div>
                        <div class="bar"></div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 text-center">
                <div class="play-live justify-content-center align-items-center d-flex flex-column h-100 text-center">
                    <h2> @if (isArabic) { راديو الغردقة } @else { Hurghada Radio } </h2>
                    <p> {{time|date:'MMM d, y, h:mm:ss a'}} </p>
                    <button class="btn btn-primary" [ngClass]="{'vibration shadow-lg': !audioService.isPlaying}" (click)="toggleRadio()"> 
                        @if (!audioService.isPlaying) {
                            <span>
                                @if (isArabic) { تشغيل الراديو } @else { play the radio } <i class="fa-solid fa-play"></i>
                            </span>
                        }
                        @else {
                            <span>
                                @if (isArabic) { توقف } @else { Pause } <i class="fa-solid fa-stop"></i>
                            </span>
                        }
                    </button>   
                    @if (audioService.isFailed) {
                        <div class="alert alert-danger mt-3">
                            {{audioService.errorMessage}}
                        </div>
                    }
                    <form class="mt-4" [formGroup]="messageForm" (ngSubmit)="sendMessage()">
                        <div class="row g-md-3 g-1">
                            <div class="mb-3 col-md-6">
                                <label for="name" class="form-label">@if (isArabic) { الاسم } @else { Name }</label>
                                <input type="text" id="name" class="form-control" [placeholder]="placeholderTextName" formControlName="name" [class.is-invalid]="messageForm.get('name')?.touched && messageForm.get('name')?.invalid" />
                                @if (messageForm.get('name')?.touched && messageForm.get('name')?.errors) {
                                  <div class="invalid-feedback">
                                    @if (messageForm.get('name')?.errors?.['required']) { @if (isArabic) { الاسم مطلوب } @else { Name is required } } 
                                    @if (messageForm.get('name')?.errors?.['minlength']) { @if (isArabic) { الاسم يجب أن يكون على الأقل 3 أحرف } @else { Name must be at least 3 characters long } } 
                                    @if (messageForm.get('name')?.errors?.['maxlength']) { @if (isArabic) { الاسم لا يمكن أن يتجاوز 60 حرفًا  } @else { Name cannot be more than 60 characters } } 
                                  </div>
                                }
                              </div>
                            
                              <div class="mb-3 col-md-6">
                                <label for="message" class="form-label">@if (isArabic) { المشاركة } @else { Sharing }</label>
                                <input type="message" id="message" class="form-control" [placeholder]="placeholderTextMessage" formControlName="message" [class.is-invalid]="messageForm.get('message')?.touched && messageForm.get('message')?.invalid" />
                                @if (messageForm.get('message')?.touched && messageForm.get('message')?.errors) {
                                  <div class="invalid-feedback">
                                    @if (messageForm.get('message')?.errors?.['required']) { @if (isArabic) { الرسالة مطلوب } @else { message is required } } 
                                    @if (messageForm.get('message')?.errors?.['minlength']) { @if (isArabic) { الرسالة يجب أن يكون على الأقل 3 أحرف } @else { message must be at least 3 characters long } } 
                                    @if (messageForm.get('message')?.errors?.['maxlength']) { @if (isArabic) { الرسالة لا يمكن أن يتجاوز 60 حرفًا }  @else { message cannot be more than 60 characters }} 
                                  </div>
                                }
                              </div>
                        </div>
                        <button type="submit" class="btn btn-primary m-2" [disabled]="messageForm.invalid" data-bs-toggle="modal" data-bs-target="#messaageSentSuccessfully"> 
                            @if(isArabic){ إرسال } @else{ Send }  <i class="fa-solid fa-paper-plane"></i>
                        </button>
                    </form>
                </div>
            </div>
            <div class="col-md-6 col-12">
              <!-- Latest News Section -->
              <div class="latest-news-section">
                <div class="section-header mb-3">
                  <h3 class="section-title">
                    <i class="fa-solid fa-newspaper mx-2"></i>
                    @if (isArabic) { آخر الأخبار } @else { Latest News }
                  </h3>
                </div>

                <!-- Loading State -->
                @if (loadingNews) {
                  <div class="news-loading text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                }

                <!-- Latest News Card -->
                @if (!loadingNews && latestNews) {
                  <a [routerLink]="['/news', latestNews.id]" class="latest-news-card">
                    <div class="news-card-modern">
                      <div class="row g-2">
                        <!-- News Image -->
                        <div class="col-md-6">
                          <div class="news-image-container">
                            <img [src]="latestNews.image" [alt]="latestNews.title" class="news-featured-image"/>
                            <div class="image-overlay-gradient"></div>
                            <span class="category-badge-modern">{{ latestNews.category }}</span>
                            <div class="read-more-overlay">
                              <i class="fa-solid fa-arrow-left mx-2"></i>
                              @if (isArabic) { اقرأ المزيد } @else { Read More }
                            </div>
                          </div>
                        </div> 
  
                        <!-- News Content -->
                        <div class="col-md-6 news-content-modern">
                          <h4 class="news-title-modern">{{ latestNews.title }}</h4>
                          <p class="news-excerpt-modern">
                            {{ (latestNews.article || '') | slice:0:150 }}...
                          </p>
                          <div class="news-meta-modern">
                            <div class="meta-item">
                              <i class="fa-solid fa-clock mx-1"></i>
                              <span>{{ latestNews.createdAt | date:'medium' }}</span>
                            </div>
                            <div class="meta-divider"></div>
                            <div class="meta-item">
                              <i class="fa-solid fa-tag mx-1"></i>
                              <span>{{ latestNews.category }}</span>
                            </div>
                          </div>
                        </div>
  
                      </div>
                    </div>
                  </a>

                  <!-- View More News Link -->
                  <div class="view-more-news mt-3">
                    <a routerLink="/news" class="btn-view-more">
                      <span>@if (isArabic) { عرض جميع الأخبار } @else { View All News }</span>
                      <!-- <i class="fa-solid fa-arrow-left "></i> -->
                      <i class="fa-solid fa-eye mx-2"></i>
                    </a>
                  </div>
                }

                <!-- No News State -->
                @if (!loadingNews && !latestNews) {
                  <div class="no-news-state text-center py-4">
                    <i class="fa-solid fa-newspaper no-news-icon"></i>
                    <p class="no-news-text">
                      @if (isArabic) { لا توجد أخبار حالياً } @else { No news available }
                    </p>
                  </div>
                }
              </div>
            </div>
        </div>
    </div>
</section> 

<section class="programs-section py-5">
  
  <div class="container">

    <h2 class="text-center mb-5 fw-bold section-title"> @if (isArabic) { برامجنا الإذاعية } @else { Our Programs } </h2>

    <div class="row g-4">

      <!-- Card 1 -->
      <div class="col-md-4">
        <div class="program-card">
          <img src="assets/images/programs/p1.jpg" class="program-img" alt="شتاء بدون شتاء" />
          <div class="program-info">
            <h4 class="program-title">شتاء بدون شتاء</h4> 
            <p class="program-time">كل يوم إثنين الساعة 6 مساءً</p>
            <p class="program-host">مع ميرنا الحسيني</p>
          </div>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="col-md-4">
        <div class="program-card">
          <img src="assets/images/programs/p1.jpg" class="program-img" alt="يوم جديد" />
          <div class="program-info">
            <h4 class="program-title">يوم جديد</h4>
            <p class="program-time">الأربعاء والسبت الساعة 10 مساءً</p>
            <p class="program-host">مع مروان سعد</p>
          </div>
        </div>
      </div>

      <!-- Card 3 -->
      <div class="col-md-4">
        <div class="program-card">
          <img src="assets/images/programs/p1.jpg" class="program-img" alt="ضيف مؤثر" />
          <div class="program-info">
            <h4 class="program-title">ضيف مؤثر</h4>
            <p class="program-time">كل يوم إثنين الساعة 8 مساءً</p>
            <p class="program-host">مع وليد العطار</p>
          </div>
        </div>
      </div>

    </div>

    <div class="join-program text-center pt-5">
      <h2> @if (isArabic) { انضم الان لفريق مذيعين راديو الغردقة } @else { Join the Hurghada Radio broadcasting team now } </h2>
      <button class="btn btn-outline-info  rounded-5" routerLink="/contact"> @if (isArabic) { انضم الان } @else { Join Now } </button>
    </div>

  </div>

</section>

<section class="about py-5">
    <div class="container">
        <div class="row g-5">
            <div class="col-md-6">
                <div class="about-thumb-wrapper overflow-hidden rounded-3">
                    <img src="assets/images/logo.png" class="w-100 rounded-3" alt="Hurghada Radio Logo" [ngClass]="{'scaled': isScaled}">
                </div>
            </div>
            <div class="col-md-6">
                <div class="about-content justify-content-center d-flex flex-column h-100">
                    <h2> @if (isArabic) { مين إحنا - راديو الغردقة } @else { Who We Are - Hurghada Radio } </h2>
                    <h3> @if (isArabic) { أفضل موسيقى FM للاستماع الخاص بك } @else { Best Music FM for Your Listening }  </h3>
                    <p> @if(isArabic){ راديو الغردقة هو صوت المدينة اللي بيعبر عن كل اللي بيحصل فيها. إحنا منصة صوتية جديدة هدفها إننا ننقل لكل الناس، سواء كانوا من سكان الغردقة أو زوارها، كل اللي يهمهم يعرفوه عن المدينة. من الأخبار المحلية، للمزيكا اللي بتناسب كل الأذواق، ولحد الفعاليات والأنشطة اللي بتحصل يوم بيوم. } @else{ Hurghada Radio is the voice of the city, reflecting everything that happens within it. We are a new audio platform dedicated to delivering essential information to both residents and visitors of Hurghada. From local news, to music that caters to all tastes, and daily updates on events and activities. } </p>
                    <a class="btn btn-primary mt-2 rounded-0" routerLink="/about"> @if (isArabic) { شاهد المزيد } @else { See More } </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="contact-info-section py-5">
    <div class="container">
      <div class="text-center mb-5">
        <h3>{{ isArabic ? 'معلومات الاتصال' : 'Contact Info' }}</h3>
      </div>
      <div class="row g-3">
        <!-- Location -->
        <div class="col-md-4" data-aos="flip-down" data-aos-duration="1000" data-aos-offset="-100">
          <a href="https://maps.app.goo.gl/MWD21HeR9FZr1bJp8" target="_blank" class="text-decoration-none">
            <div class="contact-info-box text-center">
                <div class="icon mb-3">
                  <i class="fa fa-map-marker-alt fa-2x"></i>
                </div>
                <h5>{{ isArabic ? 'الموقع' : 'Location' }}</h5>
                <p>{{ isArabic ? 'الغردقة، مصر' : 'Hurghada, Egypt' }}</p>
            </div>
          </a>
        </div>
        <!-- Phone -->
        <div class="col-md-4" data-aos="flip-down" data-aos-duration="1000" data-aos-offset="-100">
          <a href="tel:+201283015006" target="_blank" class="text-decoration-none">
            <div class="contact-info-box text-center">
                <div class="icon mb-3">
                  <i class="fa fa-phone fa-2x"></i>
                </div>
                <h5>{{ isArabic ? 'اتصال هاتفي' : 'Make a Call' }}</h5>
                <p dir="ltr"> +20 128 301 5006 </p>
            </div>
          </a>
        </div>
        <!-- message -->
        <div class="col-md-4" data-aos="flip-down" data-aos-duration="1000" data-aos-offset="-100">
          <a href="mailto:info@hurghadaradio.com" target="_blank" class="text-decoration-none">
            <div class="contact-info-box text-center">
                <div class="icon mb-3">
                  <i class="fa fa-envelope fa-2x"></i>
                </div>
                <h5>{{ isArabic ? 'الرسالة' : 'Mail' }}</h5>
                <p>info&#64;hurghadaradio.com</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </section>
  
  <!-- Modal -->
<div class="modal fade" id="messaageSentSuccessfully" tabindex="-1" aria-labelledby="messaageSentSuccessfully" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="messaageSentSuccessfully"> @if (isArabic) { تم إرسال رسالتك بنجاح، شكرًا لك 😍 } @else { Your Message Is Sent Successfully , thank you 😍 } </h1>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal"> @if (isArabic) { تمام } @else { Ok } </button>
        </div>
      </div>
    </div>
</div>